<template>
  <v-card class="px-7 py-5" elevation="3" outlined>
    <LoadingOverlay :loading="loading"/>
    <v-form v-model="valid">
      <v-container fluid>
        <v-img class="mb-2" src="https://swiset.com/wp-content/uploads/2020/05/Swiset_Imagotipo_RGB_Black.svg" max-width="100px" contain/>
        <h1>{{ $t('title', {externalName: externalName }) }}</h1>
        <v-spacer class="my-12"/>
        <p>{{ $t('description', { externalName: externalName }) }}</p>
        <v-text-field :label="$t('form.email.label')" :rules="emailRules" v-model="email" outlined/>
        <div class="d-flex align-center justify-end">
          <p class="clickable-text mb-n1 mr-5" @click="goBack" v-html="$t('btnBack')"/>
          <v-btn :disabled="!valid" class="submit-button" @click="authWithSwiset">{{ $t('btnContinue') }}</v-btn>
        </div>
        <v-divider class="mt-12 mb-3"/>
        <p class="clickable-text text-end my-0" @click="goTermsAndConditions">{{ $t('privacy') }} · {{ $t('termsAndConditions') }}</p>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import CognitoAuthRepository from "../../../repositories/cognitoAuth"
import AuthRepository from '../../../repositories/auth'


export default {
  name: "SSO",
  components: {LoadingOverlay},
  props: {
    externalName: String,
  },
  data() {
    return {
      loading: false,

      valid: false,
      email: '',
      emailRules: [
        e => !!e || this.$t('form.email.mandatory'),
        e => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e) || this.$t('form.email.notFormat'),
      ],
    }
  },
  methods: {
    goBack() {
      this.$router.push('/embed/introduction');
    },
    goTermsAndConditions() {
      window.open('https://swiset.com/terms-and-conditions/')
    },
    async authWithSwiset() {
      this.loading = true;
      // Logic to find a Swiset account with given email
      const username = (await AuthRepository.getUsernameFromEmail(this.email)).data
      if(username) { // if found, create the cognitoAuth object and associate it to the given swisetEmail
        const result = await CognitoAuthRepository.createCognitoAuthFromSwisetUser(this.$store.state.whitelabel.userEmail,this.email)
        if(!result) {
          alert("Failed registration to Authprovider from existing user")
        }else{
          this.$router.push({
            name: 'passwordless-checking',
            params: {
              email: this.email
            } 
          })
        }
      } else {
        alert(this.$t('emailNotFound'));
      }
      this.loading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/global";

.clickable-text {
  color: $border-color;
  font: 14px 'Avenir';
  cursor: pointer;
}
</style>

<i18n>
{
  "en": {
    "title": "Connect with {externalName}",
    "description": "Onetime authentication to use your Swiset account with {externalName}",
    "btnBack": "« Go Back",
    "btnContinue": "Continue »",
    "privacy": "Privacy",
    "termsAndConditions": "Terms & Conditions",
    "emailNotFound": "Email not found.\nPlease try with another email.",
    "form": {
      "email": {
        "label": "Write your email registered on Swiset",
        "mandatory": "Email is mandatory",
        "notFormat": "It doesn't look like an email"
      }
    }
  },
  "es": {
    "title": "Conectar con {externalName}",
    "description": "Onetime authentication to use your Swiset account with {externalName}",
    "btnBack": "« Ir Atrás",
    "btnContinue": "Continuar »",
    "privacy": "Privacidad",
    "termsAndConditions": "Términos & Condiciones",
    "emailNotFound": "Email no encontrado.\nPor favor intentar con otro correo.",
    "form": {
      "email": {
        "label": "Escribe tu correo registrado en Swiset",
        "mandatory": "Email es obligatorio",
        "notFormat": "No parece un email válido"
      }
    }
  }
}
</i18n>